// redux to create the store
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
//middlewares
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

// reducers
import app from './dux/app';
import builder from './dux/builder';
import env from './dux/env';

const AppStore = () => {
    const appReducer = combineReducers( {
        app,
        builder,
        env
    } );

    /*
     * thunk is a required middleware for the app
     */
    const middlewares = [ thunk ];

    /*
     * if we are running npm run prod, we do not add the createLogger middleware
     * createLogger will run in debug mode on pprd or qa,
     * just append ?debug=y to the url
     */
    if ( process.env.NODE_ENV !== 'production' ) {
        const logger = createLogger( { collapsed: true } );
        middlewares.push( logger );
    }

    return createStore(
        appReducer,
        compose(
            applyMiddleware( ...middlewares ),
            typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f
        )
    );
};

export default AppStore;